export default localStorage.getItem('session-token');